import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { DeliveryAddressService } from '@checkout-v2/feature';
import { SdModalService, SdvorButtonComponent, SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';
import { IconTypes } from '@shared/v2';
import { DeliveryAddressListComponent } from '../delivery-address-list';

@Component({
  selector: 'sd-delivery-active-address',
  imports: [SdvorButtonComponent, SdvorIconComponent],
  templateUrl: './delivery-active-address.component.html',
  styleUrls: ['./delivery-active-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeliveryActiveAddressComponent {
  protected readonly iconTypes = IconTypes;

  private readonly modalService = inject(SdModalService);
  private readonly deliveryAddressService = inject(DeliveryAddressService);
  private readonly deviceService = inject(DeviceService);

  protected readonly isDesktopLgUp = toSignal(this.deviceService.isDesktopLgUp$, { initialValue: false });
  protected readonly activeAddress = toSignal(this.deliveryAddressService.activeAddress$, { initialValue: null });

  protected changeButtonText = computed(() => `изменить ${this.isDesktopLgUp() ? '' : 'адрес'}`);

  openModal(): void {
    this.modalService.open(DeliveryAddressListComponent, {
      modalType: { xxs: 'fullscreen', md: 'compact' },
      maxWidth: { md: '425px', lg: '505px' },
      // todo: 24.06 обсудили с @srozhkov, что тут нужна задача на разобраться с модальными окнами
      // при данной стратегии не закрывается модальное окно по клику вне контента
      closeStrategy: 'backdrop',
    });
  }
}
